import { render, staticRenderFns } from "./demandProp.vue?vue&type=template&id=6938a40d&scoped=true&"
import script from "./demandProp.vue?vue&type=script&lang=js&"
export * from "./demandProp.vue?vue&type=script&lang=js&"
import style0 from "./demandProp.vue?vue&type=style&index=0&id=6938a40d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938a40d",
  null
  
)

export default component.exports